import { useMutation, useQueryClient } from "@tanstack/react-query";

import { toggleFarmFootprinting } from "services";

import { getEnvironment } from "utils";

import { GET_FARMS, GET_FARM_DETAILS, TOGGLE_FARM_FOOTPRINTING } from "consts";

export const useToggleFarmFootprinting = ({ farmId }: { farmId: string }) => {
  const isAdmin = getEnvironment().admin;

  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [TOGGLE_FARM_FOOTPRINTING, farmId, isAdmin],
    mutationFn: toggleFarmFootprinting,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_FARMS, isAdmin] });
      queryClient.invalidateQueries({ queryKey: [GET_FARM_DETAILS, farmId, isAdmin] });
    },
  });
};
